import type { RouteRecordRaw } from 'vue-router'
import { projectRouteCandidates, toAnyPermission } from '@/config/businessRoutePermissions'
import { legacyTenantRedirect, maybeRouteName, tenantScopedRedirect } from './tenantScoped'

const createProjectChildren = (withNames: boolean): RouteRecordRaw[] => [
  {
    path: '',
    ...maybeRouteName(withNames, 'projects'),
    component: () => import('@/views/project/ProjectList.vue'),
    meta: { permission: 'project:record:view' }
  },
  {
    path: 'risks',
    ...maybeRouteName(withNames, 'project-risk-board'),
    component: () => import('@/views/project/ProjectRiskBoard.vue'),
    meta: { permission: 'project:risk:view' }
  },
  {
    path: 'changes',
    ...maybeRouteName(withNames, 'project-change-board'),
    component: () => import('@/views/project/ProjectChangeBoard.vue'),
    meta: { permission: 'project:change:view' }
  },
  {
    path: 'risk-board',
    redirect: tenantScopedRedirect('/projects/risks'),
    meta: { permission: 'project:risk:view' }
  },
  {
    path: ':id',
    ...maybeRouteName(withNames, 'project-detail'),
    component: () => import('@/views/project/ProjectDetail.vue'),
    meta: { permission: 'project:record:view' }
  }
]

const projectRoutes: RouteRecordRaw[] = [
  {
    path: 't/:tenantCode/projects',
    component: () => import('@/views/project/ProjectLayout.vue'),
    meta: {
      permission: toAnyPermission(projectRouteCandidates),
      defaultRouteBasePath: '/t/:tenantCode/projects',
      defaultRouteCandidates: projectRouteCandidates,
    },
    children: createProjectChildren(true)
  },
  {
    path: 'projects',
    component: () => import('@/views/project/ProjectLayout.vue'),
    beforeEnter: legacyTenantRedirect,
    meta: {
      permission: toAnyPermission(projectRouteCandidates),
      defaultRouteBasePath: '/projects',
      defaultRouteCandidates: projectRouteCandidates,
      legacyTenantRedirect: true,
    },
    children: createProjectChildren(false)
  }
]

export default projectRoutes
